import axios from "axios";
import Endpoints from "../config/Endpoints";

export default {
    methods: {
        sendYes(pageId){
            axios.post(Endpoints.UsefulContent.Register, {
                pageId: pageId,
                yes: true
            });
            $(".toggle-when-send-form").toggle();
        },
        sendNo(pageId){
            axios.post(Endpoints.UsefulContent.Register, {
                pageId: pageId,
                no: true
            });
            $(".toggle-when-send-form").toggle();
        }
    },

}
